import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';

export const WEEKS_IN_REPORT = 12;

export const DEPLOYMENT_FREQUENCY_LEARN_MORE_COMPANY_MANAGED =
	'https://support.atlassian.com/jira-software-cloud/docs/plan-effectively-with-your-deployment-frequency-report';
export const DEPLOYMENT_FREQUENCY_LEARN_MORE_TEAM_MANAGED =
	'https://support.atlassian.com/jira-software-cloud/docs/view-and-understand-your-deployment-frequency-report';
export const IN_PRODUCT_HELP_ARTICLE_ID = '6DubDW8hmIQv9hwhu2cMQU';

/**
 * Chart
 */
export const CHART_RIGHT_SPACE_WIDTH = gridSize * 28;
export const CHART_RIGHT_SPACE_LEFT_PADDING = gridSize * 5;

/**
 * Table
 */
export const ISSUE_TABLE_ROW_INNER_HEIGHT = gridSize * 4;
